var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.sellerKind,
            callback: function($$v) {
              _vm.sellerKind = $$v
            },
            expression: "sellerKind"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "入选供方公司", name: 1 } },
            [
              _vm.sellerKind == 1
                ? _c("swb-real-adopted-com-list-select", {
                    ref: "swb_real_adopted_com_select_vendor",
                    attrs: {
                      peerMerchantType: 2,
                      filter: { peerMerchantType: 2 }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "入选服方公司", name: 3 } },
            [
              _vm.sellerKind == 3
                ? _c("swb-real-adopted-com-list-select", {
                    ref: "swb_real_adopted_com_select_servicer",
                    attrs: {
                      peerMerchantType: 4,
                      filter: { peerMerchantType: 4 }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-604eef1f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-604eef1f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/SellerXSelect.vue
// module id = 3021
// module chunks = 0